import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { GalleryAccessLevel } from '../../lib/access-level';
import { getAllowedDownloadSizes } from '../../lib/convert-gallery-download-size';

export const canDownloadAsset = (asset: AssetDto, gallery: GalleryDto, accessLevel: GalleryAccessLevel): boolean => {
  if (!gallery.download_single_asset) return false;
  if (asset.type === 'image') {
    const resp = getAllowedDownloadSizes(gallery.download_media_size, accessLevel, asset);
    if (!resp.sizes.length && !resp.allowOriginalDownload) return false;
  }
  if (gallery.approved_downloads_only) return asset.status === 'approved';
  return true;
};
